export const RouterName = {
  WELCOME: 'welcome',
  MAP_MOBILE: 'map-mb',
  HOME: 'home',
  LOGIN: 'login',
  NOT_FOUND: '404',
  NOT_HAVE_PERMISSION: '403',

  //dashboard
  DASHBOARD: 'dashboard',
  DASHBOARD_WATER_SUPPLY_NETWORK: 'dashboard.water-supply-network',
  DASHBOARD_NON_REVENUE_BY_DMA: 'dashboard.non-revenue-by-DMA',
  DASHBOARD_MASTER_METER_QUANTITY_REPORT: 'dashboard.master-meter-quantity-report',
  DASHBOARD_PRESSURE_MAP_BY_REGION: 'dashboard.pressure-map-by-region',
  DASHBOARD_CONSUMPTION_PRODUCTION_MAP: 'dashboard.consumption-roduction-map-by-region',
  DASHBOARD_NETWORK_ANOMALY_MONITORING: 'dashboard.network-anomaly',
  DASHBOARD_PRESSURE_SENSOR_DATA_REPORT: 'dashboard.pressure-sensor-data-report',
  DASHBOARD_CONSUMPTION_CORRELATION_CHART: 'dashboard.consumption-correlation-chart',
  DASHBOARD_WATER_LOSS_MAP: 'dashboard/water-loss',
  DASHBOARD_DMX_PRESSURE: 'dashboard/dmx-pressure',

  //hạ tầng tuyến ống
  PIPELINE_INFRASTRUCTURE: 'pipeline-infrastructure',

  PIPELINE_INFRASTRUCTURE_PIPELINE: 'pipeline-infrastructure.pipeline',
  PIPELINE_INFRASTRUCTURE_DEVELOPMENT_MANAGEMENT: 'pipeline-infrastructure.development-management',

  //quản lý mạng lưới
  NETWORK_MANAGEMENT: 'network-management',
  NETWORK_MANAGEMENT_MAP_PARTITION_MANAGEMENT: 'network-management.map-partition-management',
  NETWORK_MANAGEMENT_WATER_SUPPLY_AREA: 'network-management/water-supply-area',
  NETWORK_MANAGEMENT_ADM_BOUNDARY: 'network-management/adm-boundary',
  NETWORK_MANAGEMENT_VALVE_CATALOG: 'network-management/valve-catalog',
  NETWORK_MANAGEMENT_MASTER_METER: 'network-management/master-meter',
  NETWORK_MANAGEMENT_DATALOGGER: 'network-management/data-logger',
  NETWORK_MANAGEMENT_SENSOR: 'network-management/sensor',
  NETWORK_MANAGEMENT_VALVE_DATA: 'network-management/valve-data',
  NETWORK_MANAGEMENT_METER_CUSTOMER: 'network-management/meter-customer-manage',
  NETWORK_MANAGEMENT_FACTORY_PUMPING_STATION: 'network-management/factory-pumping-station',

  // vận hành theo nhu cầu
  OPERATION: 'operation',
  OPERATION_CONFIGURATION: 'operation/configuration',

  //Theo dõi bất thường
  PROJECT_MANAGEMENT: 'project-management',

  // hỗ trợ chống thất thoát
  LOSS_SUPPORT: 'loss-support',
  LOSS_SUPPORT_TERRITORIAL_LOSSES: 'loss-support/territorial-losses',
  LOSS_SUPPORT_INPUT_WATER_DATA: 'loss-support/input-water-data',
  LOSS_SUPPORT_WATER_CONSUMPTION_DATA: 'loss-support/water-consumption-data',
  LOSS_SUPPORT_METER_CUSTOMER_DATA: 'loss-support/meter-customer-data',
  LOSS_SUPPORT_METER_QUANTITY: 'loss-support/meter-quantity',
  LOSS_SUPPORT_METER_QUANTITY_SOURCE: 'loss-support/meter-quantity-source',
  LOSS_SUPPORT_LOSS_DEDUCT_TYPE: 'loss-support/loss-deduct-type',
  LOSS_SUPPORT_DMX_LOSS_DEDUCT: 'loss-support/dmx-loss-deduct',
  LOSS_SUPPORT_DATA_LOSS_BY_DMX: 'loss-support/data-loss-by-dmx',
  LOSS_SUPPORT_METER_METER_DATA: 'loss-support/master-meter-data',
  LOSS_SUPPORT_WATER_SUPPLY_OUTPUT: 'loss-support/water-supply-output',
  LOSS_SUPPORT_NETWORK_ANOMALY: 'loss-support/network-anomaly',
  LOSS_SUPPORT_NETWORK_ANOMALY_MONITORING: 'loss-support/network-anomaly-monitoring',
  LOSS_SUPPORT_NETWORK_DECLARATION_ANOMALY_RULES: 'loss-support/declaration-of-anomaly-rules',
  LOSS_SUPPORT_NETWORK_NIGHTTIME_PRODUCTION: 'loss-support/nighttime-production',

  //bản đồ mạng lưới
  NETWORK_MAP: 'network-map',

  //Theo dõi bất thường
  ANOMALY_MONITORING: 'anomaly-monitoring',
  ANOMALY_MONITORING_ALERT_GROUP: 'anomaly-monitoring/alert-group',
  ANOMALY_MONITORING_MANAGE_TIME_USE_WATER: 'anomaly-monitoring/manage-time-use-water',
  ANOMALY_MONITORING_TRACKING_PROD_NIGHTTIME: 'anomaly-monitoring/tracking-prod-nighttime',
  ANOMALY_MONITORING_ALERT: 'anomaly-monitoring/alert',
  ANOMALY_MONITORING_ALERT_LIST: 'anomaly-monitoring/alert/list',
  ANOMALY_MONITORING_ALERT_GENERAL: 'anomaly-monitoring/alert/general',
  ANOMALY_MONITORING_ALERT_DMX: 'anomaly-monitoring/alert/dmx',
  ANOMALY_MONITORING_ALERT_WARNING_STATISTICS: 'anomaly-monitoring/alert/warning-statistics',
  ANOMALY_MONITORING_FLOW: 'anomaly-monitoring/folwing',

  // Công việc hiện trường
  FIELDWORK: 'field-work',
  FIELDWORK_TICKET_GROUP: 'field-work/ticket-group',
  FIELDWORK_TICKET_TYPE: 'field-work/ticket-type',
  FIELDWORK_TICKET_TYPE_ORG: 'field-work/ticket-type-org',
  FIELDWORK_TICKET_MANAGE: 'field-work/ticket-manage',
  FIELDWORK_TICKET_DETAIL: 'field-work/ticket-manage/detail',
  FIELDWORK_ROUTES: 'field-work/routes',
  FIELDWORK_QUOTA_NORM: 'field-work/quota-norm',
  FIELDWORK_PIECE_WAGE_MANAGE: 'field-work/piece-wage-manage',
  FIELDWORK_PIECE_WAGE_DETAIL: 'field-work/piece-wage-manage/detail'
}
export const UriRole = {
  DASHBOARD_WATER_SUPPLY_AREA: '/dashboard/water-supply-network',
  DASHBOARD_MASTER_METER_QUANTITY_REPORT: '/dashboard/master-meter-quantity-report',
  DASHBOARD_CONSUMPTION_CORRELATION_CHART: '',
  DASHBOARD_WATER_LOSS: '/anomaly-monitoring/dashboard-water-loss',
  DASHBOARD_DMX_PRESSURE: '/dashboard/dmx-pressure-data',

  MAP_PARTITION_MANAGEMENT: '/map-partition',
  PIPELINE_INFRASTRUCTURE: '/pipe',
  WATER_SUPPLY_AREA: '/water-supply-area',
  ADM_BOUNDARY: '/adm-boundary',
  MASTER_METER: '/master-meter',
  DATA_LOGGER: '/datalogger',
  SENSOR: '/sensor',
  MASTER_METER_DATA: '/master-meter-data',
  FACTORY: '/factory',
  NETWORK_MANAGEMENT_METER_CUSTOMER: '/meter-customer-data',

  LOSS_SUPPORT_METER_QUANTITY: '/meter-quantity-data',
  LOSS_SUPPORT_METER_QUANTITY_SOURCE: '/meter-quantity-data',
  LOSS_SUPPORT_WATER_CONSUMPTION_DATA: '/consumption-production-data-dmx',
  LOSS_SUPPORT_INPUT_WATER_DATA: '/input-production-data-dmx',
  LOSS_SUPPORT_WATER_SUPPLY_OUTPUT: '',
  LOSS_SUPPORT_DMX_LOSS_DEDUCT: '/dmx-loss-deduct',
  LOSS_SUPPORT_LOSS_DEDUCT_TYPE: '/loss-deduct-type',
  LOSS_SUPPORT_DATA_LOSS_BY_DMX: '/dmx-water-loss',

  ANOMALY_MONITORING_ALERT_GROUP: '/alert-group',
  ANOMALY_MONITORING_ALERT_STATS_DNP: '/alert/stats/dnp',
  ANOMALY_MONITORING_ALERT_STATS_DMX: '/alert/stats/dmx',
  ANOMALY_MONITORING_ALERT: '/alert',
  ANOMALY_MONITORING_PAGE: '/anomaly-monitoring',
  ANOMALY_MONITORING_FLOW_DIFF: '/alert-flow-diff',

  MANAGE_TIME_WATER: '/hour-level',

  FIELDWORK_TICKET_TYPE: '/field-work/ticket-type',
  FIELDWORK_TICKET_TYPE_ORG: '/field-work/ticket-type-org',
  FIELDWORK_TICKET_GROUP: '/field-work/ticket-group',
  FIELDWORK_TICKET_MANAGE: '/field-work/ticket-manage',
  FIELDWORK_QUOTA_NORM: '/quota-norm',
  FIELDWORK_PIECE_WAGE_MANAGE: '/field-work/piece-wage'
}
